import { createDecorator, ProcessHandler } from './middleware';
import { isPromise, performanceNow } from '../utils';
import RtcError from '../../common/rtc-error';
import kvStatManager from '../../manager/kv-stat-manager';

/**
 * 给方法调用添加KV上报
 * @param key 上报的key值
 * @param reportCost 是否需要上报耗时
 */
export function reportSuccessRate(key: number, reportCost: boolean) {
  return createDecorator((next: ProcessHandler, name: string) => function (this, ...args: any[]) {
    const kvReportKey = key;
    try {
      const res = next.apply(this, args);
      const now = performanceNow();
      if (isPromise(res)) {
        return res.then(val => {
          if (reportCost) {
            kvStatManager.addSuccessEvent({ key: kvReportKey, cost: performanceNow() - now });
          } else {
            kvStatManager.addSuccessEvent({ key: kvReportKey });
          }
          return val;
        }).catch(error => {
          kvStatManager.addFailedEvent({ key: kvReportKey, error });
          throw error;
        });
      }
      kvStatManager.addSuccessEvent({ key: kvReportKey });
      return res;
    } catch (error) {
      kvStatManager.addFailedEvent({ key: kvReportKey, error: error as RtcError });
      throw error;
    }
  });
}
